import { NO_CONTENT } from "~/modules/dtwin/constants";
import type { Dtwin } from "~/modules/dtwin/models/Dtwin.interface";
import type { OptionEnumLabel } from "~/modules/dtwin/models/DynamicUICommon.interface";

/**
 * Get the option corresponding to the value associated with ID
 * Return the value if the option does not exist
 * @param options list of options possible
 * @param id property of the field in row
 * @param dtwin
 */
export function getOptionValue(
  options: OptionEnumLabel[],
  id: string,
  dtwin: Dtwin,
) {
  const value = getValue(id, dtwin);
  const findOption: OptionEnumLabel | undefined = options.find(
    (option: OptionEnumLabel) => {
      return option.enumValue === value;
    },
  );
  return findOption?.labelCustom || findOption?.label || value || NO_CONTENT;
}

/**
 * Get the value corresponding to the ID
 * @param id property of the field in twin
 * @param dtwin
 */
export function getValue(id: string, dtwin: Dtwin): unknown | undefined {
  const properties = id.split(".");
  let i = 0;
  let value: unknown = dtwin;
  while (value !== undefined && i < properties.length) {
    value = value[properties[i]];
    i++;
  }
  return value;
}
